var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTimerIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#005D98",
  clipPath: "url(#timer-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.5 3c-4.744 0-8.625 4.05-8.625 9s3.881 9 8.625 9 8.625-4.05 8.625-9-3.881-9-8.625-9m0 16.2c-3.804 0-6.9-3.231-6.9-7.2s3.096-7.2 6.9-7.2 6.9 3.231 6.9 7.2-3.096 7.2-6.9 7.2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.781 8.001c0-.43.327-.766.745-.766s.745.337.745.766v4.206l2.016 1.14a.78.78 0 0 1 .29 1.047.78.78 0 0 1-.653.392.62.62 0 0 1-.363-.093l-2.398-1.364a.77.77 0 0 1-.382-.673z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "timer-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h23v24H0z"
})))));
export default SvgTimerIcon;